import api from 'api';

export const loadTrafficTypes = api(
  'GET /api/creatives-tracker/filters/trafficTypes'
);

export const loadApplications = api(
  'GET /api/creatives-tracker/filters/applications'
);

export const loadNetworks = api('GET /api/creatives-tracker/filters/networks');

export const loadClusters = api('GET /api/creatives-tracker/filters/clusters');

export const loadBusinessPartners = api(
  'GET /api/creatives-tracker/filters/business-partners'
);
export const loadAffiliates = api(
  'GET /api/creatives-tracker/filters/affiliates'
);
export const loadCampaigns = api(
  'POST /api/creatives-tracker/filters/campaigns'
);

export const loadManagers = api('GET /api/creatives-tracker/filters/managers');
export const loadOwners = api('GET /api/creatives-tracker/filters/owners');
export const loadPlatforms = api(
  'GET /api/creatives-tracker/filters/platforms'
);

export const loadGenres = api('GET /api/creatives-tracker/filters/genres');
export const loadCountries = api(
  'GET /api/creatives-tracker/filters/countries'
);

export const loadChannelTypes = api(
  'GET /api/creatives-tracker/filters/channelTypes'
);
export const loadChannels = api('GET /api/creatives-tracker/filters/channels');
export const loadLabels = api('GET /api/creatives-tracker/filters/labels');

export const loadClients = api('GET /api/creatives-tracker/filters/clients');
export const loadDeviceTypes = api(
  'GET /api/creatives-tracker/filters/device-types'
);
export const loadRealCPFlows = api('GET /api/creatives-tracker/filters/flows');

export const loadRegistrations = api(
  'GET /api/creatives-tracker/filters/registrations'
);
export const loadCampaignTypes = api(
  'GET /api/creatives-tracker/filters/targetingactivitytypes'
);

export const loadFraudTypes = api(
  'GET /api/creatives-tracker/filters/fraud-types'
);

export const loadReCounters = api(
  'GET /api/creatives-tracker/filters/re-counters'
);
